module.exports = __webpack_public_path__ + "static/lisaPro-f2fd566179439e1bd1e37402d6fa44be.png";